import { UgoPipelineMaterialTypeResponseDTO } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { UgoPipelineMaterialTypeController } from 'cd-eft/services/eftSetApi';
import { observable } from 'mobx';
export class UgoMaterialPageVM {
  @observable pipelineMaterials: UgoPipelineMaterialTypeResponseDTO[] = [];

  constructor() {
    this.getUgoMaterials();
  }

  async getUgoMaterials() {
    try {
      const response = await UgoPipelineMaterialTypeController.getAllUgoPipelineMaterialTypesUsingGET();
      this.pipelineMaterials = response?.data || [];
    } catch (err) {
      MessageCenter.addError("Failed to fetch pipeline material types.");
    }
  }
}